module.exports = __webpack_public_path__ + "img/tn-timeline-main-7.bc39ba3a.jpg";